import React, { useState } from "react";

const SearchBar = ({ onSearch }) => {
    const [texto, setTexto] = useState("");

    const submit = (e) => {
        e.preventDefault();
        onSearch(texto);
    };

    return (
        <form className="search-bar" onSubmit={submit}>
            <input
                type="text"
                placeholder="Buscar cursos..."
                value={texto}
                onChange={(e) => setTexto(e.target.value)}
            />
            <button type="submit">Buscar</button>
        </form>
    );
};

export default SearchBar;
